import React, { Component } from "react";
import { isLoggedIn } from "../services/AuthenticationService";
import { translate } from "react-i18next";
import "./styles/dashboard.css";
import "./styles/dashboardModern.css";
import { bindActionCreators } from "redux";
import mainViewActions from "../actions/mainViewActions";
import connect from "react-redux/es/connect/connect";
import Carousel from "re-carousel";
import PropTypes from "prop-types";
import moment from "moment";
import { Bubble } from "react-chartjs-2";
import { Loading, RichDropdown} from "../components";
import { SYMPTOM_UNITS_NEW } from "../actions/constant";
import { Row, Col } from "reactstrap";
import { loginRequired } from "../services/UserService";
import SymptomChart from "../components/SymptomChart";
import i18n from "../i18n";


// Adapter so RichDropdown (redux-form style) works with a plain onChange(e)
const SimpleRichDropdown = ({ value, onChange, options, placeholder, disabled, className }) => {
  // Build a redux-form-like input prop
  const input = {
    name: "dashboard_user",
    value,
    onChange: (evtOrVal) => {
      // RichDropdown will send a DOM-like event with target.value
      if (evtOrVal && evtOrVal.target) {
        // Ensure currentTarget for your selectChange(e) reads correctly
        const v = evtOrVal.target.value;
        const eventForLegacy = {
          ...evtOrVal,
          currentTarget: { value: v },
        };
        onChange(eventForLegacy);
        return;
      }
      // If a raw value ever comes through, normalize to an event shape
      onChange({
        target: { value: evtOrVal },
        currentTarget: { value: evtOrVal },
      });
    },
  };

  return (
    <div className={className || ""}>
      <RichDropdown
        input={input}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

function Dot(props) {
  return (
    <span
      style={{
        display: "inline-block",
        height: "8px",
        width: "8px",
        borderRadius: "4px",
        backgroundColor: "white",
        margin: "7px 5px",
        opacity: props.selected ? "1" : "0.3",
        transitionDuration: "300ms",
      }}
      onClick={props.select}
    />
  );
}
function IndicatorDots(props) {
  const wrapperStyle = {
    position: "absolute",
    width: "100%",
    zIndex: "100",
    bottom: "-10px",
    textAlign: "center",
  };
  const select = (index, e) => {
    for (let i = 0; i < Math.abs(props.index - index); i++) {
      if (props.index > index) {
        setTimeout(function () {
          props.prevHandler();
        }, i * 50);
      } else {
        setTimeout(function () {
          props.nextHandler();
        }, i * 50);
      }
    }
  };
  if (props.total < 2) {
    // Hide dots when there is only one dot.
    return <div style={wrapperStyle} />;
  } else {
    return (
      <div style={wrapperStyle}>
        {Array.apply(null, Array(props.total)).map((x, i) => {
          return (
            <Dot
              key={i}
              selected={props.index === i}
              select={select.bind(this, i)}
            />
          );
        })}
        <a href="/main" className="indicator-bar">
          <i
            className="fa fa-cog"
            style={{
              color: "#979595",
            }}
          />
        </a>
      </div>
    );
  }
}

IndicatorDots.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

class Chartview extends React.Component {
  componentDidMount() { }

  render() {
    const periodSelected = this.props.timeSelection;
    const data = {
      labels: this.props.chartPeriod,
      datasets: [
        {
          id: 1,
          xAxisID: "xAxis1",
          borderColor: "#ff0000",
          borderWidth: 2,
          data: [],
        },
      ],
    };
    const options = {
      tooltips: {
        callbacks: {
          title: function (tooltipItem, chartData) {
            return (
              moment(tooltipItem[0]["xLabel"]).format("MMMM Do YYYY, h:mm a") +
              ", " +
              tooltipItem[0]["yLabel"]
            );
          },
          label: function () {
            return null;
          },
        },
        displayColors: false,
      },
      scales: {
        xAxes: [
          {
            id: "xAxis1",
            bounds: "ticks",
            type: "time",
            ticks: {
              source: "labels",
              fontSize: 12,
              fontColor: "transparent",
              fontStyle: "bold",
              callback: function (label, index) {
                var time = label;
                if (
                  time === moment().format("MMM DD") ||
                  time === moment().format("MMM YYYY")
                ) {
                  time = i18n.t("general.DATE_PICKER_TEXT");
                }
                if (index === 0) {
                  time = " ";
                }

                return time;
              },
            },
          },
        ],
        yAxes: [
          {
            type: "linear",
            ticks: {
              beginAtZero: true,
              fontColor: "transparent",
            },
          },
        ],
      },
    };
    const legendOpts = {
      display: false,
    };
    return (
      <div className="chart">
        <Bubble data={data} options={options} legend={legendOpts} />
      </div>
    );
  }
}
class Subview extends React.Component {
  componentDidMount() { }
  postCharLimit(text) {
    var str = text;
    if (str && str.length > 290) {
      str = str.substring(0, 290) + "...";
    }
    return str;
  }
  timePreiodLabel(time) {
    switch (time) {
      case "1M":
        return this.props.t("stocks.1M_GRAPH_TEXT");
      case "3M":
        return this.props.t("stocks.3M_GRAPH_TEXT");
      case "6M":
        return this.props.t("stocks.6M_GRAPH_TEXT");
      case "1Y":
        return this.props.t("stocks.1Y_GRAPH_TEXT");
      case "2Y":
        return this.props.t("stocks.2Y_GRAPH_TEXT");
      default:
        return false;
    }
  }
  render() {
    const timeSelections = ["1M", "3M", "6M", "1Y", "2Y"];
    var _chartView = (
      <SymptomChart
        data={this.props.item.graph}
        chartPeriod={this.props.chartPeriod}
        timeSelection={this.props.timeSelection}
        symptomKey={this.props.selectedSymptom}
      />
    );
    if (this.props.item.graph.length === 0) {
      _chartView = (
        <div
          style={{
            flex: 1,
            alignContent: "center",
            textAlign: "center",
            paddingTop: 20,
          }}
        >
          {this.props.t("general.NO_DATA_FOUND_TEXT")}
        </div>
      );
    }

    var _newsList = <li />;
    if (this.props.item !== undefined) {
      if (this.props.item.news !== undefined) {
        _newsList = this.props.item.news.map((news, key) => {
          return (
            <li className="list-group-item" key={key}>
              <a href={news.url}>{news.title}</a>
              <br />
              {news.author}
              {typeof news.author != "undefined" &&
                news.author != null &&
                news.author != "" && <br />}
              {moment(news.publishedAt).format("DD MMM YYYY")}
            </li>
          );
        });
      }
    }
    var _forumList = <li />;
    if (this.props.item !== undefined && !this.props.customSymptom) {
      if (
        this.props.item.forum !== undefined &&
        this.props.item.forum.length > 0
      ) {
        _forumList = this.props.item.forum.map((post, key) => {
          return (
            <li className="list-group-item" key={key}>
              <a href={"/forum/post/" + post._id}>
                {post.date
                  ? moment.unix(post.date).format("DD MMM YYYY, hh:mma")
                  : moment(post.created_at).format("DD MMM YYYY, hh:mma")}
              </a>
              <br />
              <span style={{ color: "#f44336" }}>
                {post.publish_status === "republished"
                  ? this.props.t("forum.EDITED_TEXT")
                  : ""}
              </span>{" "}
              {this.postCharLimit(post.body)}
              {/* {post.body} */}
            </li>
          );
        });
      } else {
      }
    }
    if (this.props.item.forum.length == 0) {
      _forumList = (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "400",
            padding: "20px",
          }}
        >
          {this.props.t("dashboard.NO_POST_FOUND")}
        </div>
      );
    }
    if (this.props.customSymptom) {
      _forumList = (
        <div
          style={{
            fontSize: "16px",
            fontWeight: "400",
            padding: "20px",
            textAlign: "center",
          }}
        >
          {this.props.t("dashboard.NO_POST_FOUND_FOR_CUSTOM_SYMPTOM")}
        </div>
      );
    }
    return (
      <Carousel widgets={[IndicatorDots]}>
        <div className="subview-item">
          <div className="time-selection">
            {timeSelections.map((time, key) => {
              const k =
                time == this.props.timeSelection
                  ? "time-item active"
                  : "time-item";
              return (
                <a
                  className={k}
                  key={key}
                  onClick={this.props.selectTime.bind(
                    this,
                    this.props.selectedSymptom,
                    time
                  )}
                >
                  {this.timePreiodLabel(time)}
                </a>
              );
            })}
          </div>
          {_chartView}
        </div>
        <div className="subview-item">
          <ul className="list-group group-small">{_forumList}</ul>
        </div>
        <div
          className="subview-item"
          style={{
            paddingTop: "4rem",
          }}
        >
          <p style={{ fontSize: "18px", marginLeft: "5.3rem" }}>
            {this.props.t("dashboard.NEWS_COMING_SOON_TITLE")}
          </p>
          <p
            style={{
              fontSize: "1rem",
              marginLeft: "5.3rem",
              paddingRight: "4.6rem",
            }}
          >
            {this.props.t("dashboard.NEWS_COMING_SOON_TEXT_1")} <br></br>
            <a
              className="comingSoonLink"
              href="/infoandsupport?topic=feedback"
              onClick={() => {
                localStorage.setItem("infoAndSupport", "feedback");
              }}
            >
              {this.props.t("dashboard.CLICK_HERE_TEXT")}
            </a>
            {this.props.t("dashboard.NEWS_COMING_SOON_TEXT_2")}
          </p>
        </div>
      </Carousel>
    );
  }
}
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chooseUser: "",
    };
    this.toggleSeverity = this.toggleSeverity.bind(this);
  }
  componentDidMount() { }
  getClass = (val) => {
    let name = "btn btn-sm ";
    //   if(val==0)name +='normal';
    //   else if(val>=1 && val<=3)name +='mild';
    //   else if(val>=4 && val<=6)name +='moderate';
    //   else if(val>=7 && val<=10)name+='severe';
    return `${name}severity${val}`;
  };
  getColor(id, size) {
    let units = SYMPTOM_UNITS_NEW();
    let colors = [];
    let color = "";
    let values = [];
    let sizeindex = "";
    units.map((element) => {
      if (element._id == id) {
        colors = element.colour;
        values = element.value;
      }
    });

    if (colors) {
      const valueNums = [];
      values.map((num) => {
        valueNums.push(Number(num));
      });
      for (var i = 0; i < valueNums.length; i++) {
        if (valueNums[i] == size) {
          sizeindex = i;
        }
      }

      color = colors[sizeindex | 0];
    } else {
      color = "255, 255, 255";
    }
    const mystyle = {
      backgroundColor: `rgb(${color})`,
    };
    if (color == "204, 0, 0" || color == "153, 0, 0") {
      mystyle.color = "#fff";
    }
    return mystyle;
  }
  toggleSeverity = (e) => {
    this.props.toggleSeverity();
    e.stopPropagation();
  };
  selectChange(e) {
    var resutl = {};
    this.props.users.map((element) => {
      if (element._id == e.currentTarget.value) {
        resutl = element;
      }
    });

    localStorage.setItem("Dashboard_User_Selected", JSON.stringify(resutl));

    this.props.changeSelectStatus();
    this.props.changeUserStocks(resutl);
  }

  render() {
    let { items, users, selectedUser, t, DateMode } = this.props;
    var selectedId = "";
    if (selectedUser) {
      selectedId = selectedUser._id;
    }
    return (
      <div className="listSection">
        {/* <div
          className="dropDownDashboard"
          style={{
            border: "1px solid white",
            borderRadius: 4,
            marginBottom: "5px",
            height: "33.59px",
          }}
        >
          <select
            className="form-control chooseUser"
            onChange={this.selectChange.bind(this)}
            value={selectedId}
            style={{
              border: 0,
              borderRight: `5px solid transparent`,
            }}
          >
            {users &&
              users.map((element) => {
                let name = `${element.first_name} ${element.last_name}`;
                const displayText =
                  name.length > 30 ? name.substring(0, 30) + "..." : name;
                return (
                  <option key={element._id} value={element._id}>
                    {element.first_name} {element.last_name}
                  </option>
                );
              })}
          </select>
        </div> */}

        <div
          className="dropDownDashboard"
        >
          {/* <SimpleRichDropdown
            value={selectedId}                // current user id
            onChange={this.selectChange.bind(this)}
            disabled={false}
            options={
              (users || []).map(u => ({
                value: u._id,
                // Label as plain text; RichDropdown will auto-wrap with .nut-name via renderLabel
                label: `${u.first_name} ${u.last_name}`,
              }))
            }
          /> */}

          <RichDropdown
            input={{
              name: "dashboard_user",
              value: selectedId, // current user id
              onChange: (evtOrVal) => {
                // RichDropdown will send a DOM-like event with target.value.
                // Ensure currentTarget.value exists for selectChange(e).
                const val = evtOrVal && evtOrVal.target ? evtOrVal.target.value : evtOrVal;
                const legacyEvent = {
                  ...(evtOrVal || {}),
                  target: { value: val },
                  currentTarget: { value: val },
                };
                this.selectChange(legacyEvent);
              },
            }}
            options={(users || []).map((u) => ({
              value: u._id,
              label: `${u.first_name} ${u.last_name}`,
            }))}
            // No placeholder for User (per your spec)
            disabled={false}
            t={this.props.t}
          />

        </div>


        {items && items.length > 0 ? (
          <ul className="list-group small-part">
            {items &&
              items.map((value, index) => {
                let className = "list-group-item";
                if (
                  typeof value.isSelected != "undefined" &&
                  value.isSelected == 1
                )
                  className += " selected";
                return (
                  <li
                    className={className}
                    key={index}
                    onClick={() =>
                      this.props.selectItem(
                        value,
                        this.props.timeSelection,
                        t("general.CATEGORY_SYMPTOM")
                      )
                    }
                  >
                    <Row>
                      <Col xs="8">
                        <span
                          style={{
                            overflowWrap: "break-word",
                            cursor: "default",
                            lineHeight: "20px",
                          }}
                        >
                          <Row style={{ marginLeft: "-15px" }}>
                            <div style={{ width: "45px", textAlign: "right" }}>
                              <Col xs="auto">{index + 1 + ". "}</Col>
                            </div>
                            <Col xs="10" style={{ textAlign: "left" }}>
                              {value.symptom}
                            </Col>
                          </Row>
                        </span>
                      </Col>
                      <Col xs="4">
                        {!DateMode && (
                          <span className="info" onClick={this.toggleSeverity}>
                            <span className="state">
                              {value.arrow == "up" && (
                                <i
                                  className="fa fa-arrow-up"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                              {value.arrow == "down" && (
                                <i
                                  className="fa fa-arrow-down"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </span>
                            <button
                              style={this.getColor(
                                value.unitid,
                                value.severity
                              )}
                              className="btn btn-sm"
                            >
                              {value.severity}
                            </button>
                          </span>
                        )}
                        {DateMode && (
                          <span className="info" onClick={this.toggleSeverity}>
                            <span
                              className="state"
                              style={{ cursor: "pointer" }}
                            >
                              {moment(parseInt(value.date)).format("MMM DD")}
                            </span>
                            <button
                              style={this.getColor(
                                value.unitid,
                                value.severity
                              )}
                              className="btn btn-sm"
                            >
                              {moment(parseInt(value.date)).format("HH:mm")}
                            </button>
                          </span>
                        )}
                      </Col>
                    </Row>
                  </li>
                );
              })}
          </ul>
        ) : (
          <p
            style={{
              color: "white",
              padding: "30px 15px",
            }}
          >
            {t("dashboard.NO_SYMPTOM_IN_DISPLAY")}
          </p>
        )}
      </div>
    );
  }
}

class MainView extends Component {
  constructor(props) {
    super(props);
    this.fistChangeStoks = true;
    this.changeSelectStatus = this.changeSelectStatus.bind(this);
  }
  async componentDidMount() {
    if (!isLoggedIn()) {
      this.props.history.push("/");
      return;
    }
    await loginRequired(this.props);
    var baseUser = localStorage.getItem("user");
    let user = JSON.parse(baseUser);
    await this.props.getSymptomUsers(user._id);

    var selectedUser = localStorage.getItem("Dashboard_User_Selected");
    selectedUser = JSON.parse(selectedUser);
    if (selectedUser) {
      this.props.getdetailStocks(selectedUser);
    } else {
      this.props.getdetailStocks(user);
    }
    window.selected_id = 0;
    this.baseUser = user;
  }
  componentDidUpdate() {
    if (
      this.fistChangeStoks &&
      this.props.stocks &&
      this.props.stocks.length > 0
    ) {
      this.fistChangeStoks = false;
      this.props.selectItem(
        this.props.stocks[0],
        this.props.timeSelection,
        this.props.t("general.CATEGORY_SYMPTOM")
      );
    }
  }
  componentWillUnmount() {
    this.props.resetPage();
  }
  changeSelectStatus() {
    this.fistChangeStoks = true;
  }
  render() {
    const {
      t,
      isLoading,
      DateMode,
      selectedUser,
      changeUserStocks,
      allUser,
      timeSelection,
      selectedSymptom,
    } = this.props;
    return (
      <div className="black-container dashboard-modern">
        <Loading isLoading={isLoading} />
        <div className="stock">
          <List
            items={this.props.stocks}
            selectItem={this.props.selectItem}
            getdetailStocks={this.props.getdetailStocks}
            toggleSeverity={this.props.toggleSeverity}
            users={allUser}
            baseUser={this.baseUser}
            selectedUser={selectedUser}
            changeUserStocks={changeUserStocks}
            t={t}
            DateMode={DateMode}
            timeSelection={timeSelection}
            selectedSymptom={selectedSymptom}
            changeSelectStatus={this.changeSelectStatus}
          />
          <div className="subview">
            <Subview
              item={this.props.selected}
              timeSelection={this.props.timeSelection}
              selectTime={this.props.selectTime}
              selectedSymptom={selectedSymptom}
              chartPeriod={this.props.chartPeriod}
              t={t}
              customSymptom={this.props.customSymptom}
            />
          </div>
        </div>
      </div>
    );
  }
}

MainView = translate("translations")(MainView);

const mapStateToProps = (state) => ({ ...state.mainView });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...mainViewActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(MainView);



// WEBPACK FOOTER //
// ./src/pages/MainView.js